import { Component, NgModule, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { UserPanelModule } from '../user-panel/user-panel.component';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';

import { AuthService } from '../../services';
import { IdentityUser } from 'src/app/core/models/identity-user.model';
import { formatMessage } from 'devextreme/localization';
@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  @Output()
  menuToggle = new EventEmitter<boolean>();

  @Input()
  menuToggleEnabled = false;

  @Input()
  title!: string;

  user: IdentityUser;

  userMenuItems = [{
    text: formatMessage('Profile'),
    icon: 'user',
    onClick: () => {
      this.router.navigate(['/profile']);
    }
  },
  {
    text: formatMessage('Sign out'),
    icon: 'runner',
    onClick: () => {
      this.authService.logOutAsync();
    }
  }];

  constructor(private authService: AuthService, private router: Router) {
    this.user = {
      publicId: '',
      userName: '',
      isActive: false,
      isAdmin: false,
      firstName: '',
      lastName: '',
      email: '',
      preferredLanguage: ''
    };
  }

  async ngOnInit(): Promise<void> {
    this.user = this.authService.getIdentity();
  }

  toggleMenu = () => {
    this.menuToggle.emit();
  }
}

@NgModule({
  imports: [
    CommonModule,
    DxButtonModule,
    UserPanelModule,
    DxToolbarModule
  ],
  declarations: [ HeaderComponent ],
  exports: [ HeaderComponent ]
})
export class HeaderModule { }
